package ai.flowstorm.common.ui

import io.kvision.core.Overflow
import io.kvision.core.onEvent
import io.kvision.panel.SimplePanel

abstract class PropertiesEditor<E : Any>(val className: String? = "panel-view-nav1") : SimplePanel(className = className), ReadOnly {

    private lateinit var model: E
    abstract val form: Form<E>

    override var readOnly: Boolean = true
        set(value) {
            form.disabled = value
            field = value
        }


    fun init() {
        paddingTop = UiHelpers.spacing
        paddingRight = UiHelpers.spacing
        if (!className.isNullOrEmpty())
            overflow = Overflow.SCROLL
        add(form.apply {
            onEvent {
                change = {
                    save(model)
                }
            }
        })
    }

    fun load(model: E) {
        this.model = model
        form.setData(model)
    }
}